import { useContext, useState } from "react";
import range from "../../util/range";
import { EditorContext } from "../EditorCommon/EditorContext";


export function DoorNumSetter(props: Exclude<React.HTMLProps<HTMLSelectElement>, { value: any, onchange: any }>) {
    const ec = useContext(EditorContext);


    const [numDoorsStr, setNumDoorsStr] = useState(ec.cabinet.doors.length.toString());

    async function setNumDoors(evt: React.ChangeEvent<HTMLSelectElement>) {
        const newValStr = evt.target.value;
        const newVal = parseInt(newValStr);
        const result = await ec.cabinetService.setNumDoors(newVal);
        if (!result.success)
            return;

        setNumDoorsStr(newValStr);
    }


    const doorChoices = ec.cabinetService.getNumDoorChoices();
    function doorChoiceTranslator(n: number) {
        return ec.translator("doorEditor numDoors option", "{doors} Døre", { doors: n.toString() });
    }
    const numDoorChoices = range(doorChoices.min, doorChoices.max + 1)
        .map(n => <option value={n} key={n}>{doorChoiceTranslator(n)}</option>);


    return (
        <select {...props}
            value={numDoorsStr}
            onChange={setNumDoors}
        >
            {numDoorChoices}
        </select>
        
    );

}
